var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"h-full",attrs:{"fluid":""}},[_c('leads')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }